import React, { useEffect, useState } from 'react';
import { TabComponentProps } from 'types/common';
import _ from 'lodash';
import { Descriptions, DescriptionsProps, Spin, Table, message } from 'antd';
import api from 'api';
import { get } from 'utils/fetch';
import Paragraph from 'antd/es/typography/Paragraph';
// import { BasicInfoKeyNameMap } from './const';

const ProjectDetails: React.FC<TabComponentProps> = ({ nameid }) => {
    return <div className="dfdfd">
        <h2>INVESTMENT SUMMARY</h2>
        <Paragraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Paragraph>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/KrshsWGjIsY?si=IpbUPc-Qf8L3qG82" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </div>
}

export default ProjectDetails;
